import { render, staticRenderFns } from "./SubcategoriesManagement.vue?vue&type=template&id=39ffc0a0&"
import script from "./SubcategoriesManagement.vue?vue&type=script&lang=js&"
export * from "./SubcategoriesManagement.vue?vue&type=script&lang=js&"
import style0 from "./SubcategoriesManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports